export function createLatestOnlyRunner(run, options = {}) {
    let running = null;
    let waiting = null;
    let disposed = false;
    const start = (value) => {
        const controller = new AbortController();
        running = controller;
        const timer = options.timeoutMs
            ? setTimeout(() => controller.abort(), options.timeoutMs)
            : undefined;
        const settle = () => {
            clearTimeout(timer);
            running = null;
            if (disposed || !waiting)
                return;
            const next = waiting;
            waiting = null;
            start(next.value);
        };
        new Promise((resolve) => resolve(run(value, controller.signal))).then(settle, settle);
    };
    return {
        push(value) {
            if (disposed)
                return;
            if (running)
                waiting = { value };
            else
                start(value);
        },
        dispose() {
            disposed = true;
            waiting = null;
            running?.abort();
        },
    };
}
//# sourceMappingURL=latest-only-runner.js.map